import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import CallToActions from '../../components/common/CallToActionsActivity';
import Seo from '../../components/common/Seo';
import Header11 from '../../components/header/header-rslhome';
import DefaultFooter from '../../components/footer/footer-3';
import StepperBooking from '../../components/booking-page-activity/stepper-booking';
import { fetchSeoByPage } from '../../lib/seoHelper';

const Index = ({ meta }) => {
  const router = useRouter();
  const {
    _id,
    city,
    checkIn,
    checkOut,
    adult,
    choiceId,
    child,
    packageName,
    choiceName,
    image,
    date,
    time,
    adultAmt,
    currency,
    childAmt,
    vendorId,
    totalPay,
    vat,
    withPickup,
    termAndCondition
  } = router.query;
  // const pickupPointJson = router.query.pickupPoint;
  // const pickupPoint = pickupPointJson ? JSON.parse(pickupPointJson) : [];

  const [click, setClick] = useState(false);
  const [values, setValues] = useState({
    name: '',
    email: '',
    phone: '',
    // address1:"",
    // address2:"",
    // state:"",
    countryCode: '',
    // zipcode:"",
    specialRequest: '',
  });
  const [searchCountryCodeValue, setSearchCountryCodeValue] = useState('');
  const [formLoading, setFormLoading] = useState(true);

  const { userData } = useSelector((state) => state.user);
  const handleCurrency = () => {
    setClick((prevState) => !prevState);

    // router.push("/sign-in/sign-in");
    // sessionStorage.setItem('bookingPath', currentPath);
  };
  function handleBooking() {
    if (JSON.parse(sessionStorage.getItem('rslkey')) !== null) {
      // 
    } else {
      handleCurrency();
    }
  }

  useEffect(() => {
    if (userData) {
      if (
        searchCountryCodeValue === '' &&
        searchCountryCodeValue !== userData?.countryCode
      ) {
        setFormLoading(true);
        setValues(userData);
        setSearchCountryCodeValue(userData?.countryCode);
      }
    } else {
      setValues({
        name: '',
        email: '',
        phone: '',
        countryCode: '+971',
        specialRequest: '',
      });
      setFormLoading(false);
    }
  }, [userData]);

  useEffect(() => {
    // Check if router.query is empty
    if (Object.keys(router.query).length === 0) {
      // Get stored booking query from sessionStorage
      const storedQuery = sessionStorage.getItem('bookingQueryUrl');
      if (storedQuery) {
        const parsedQuery = JSON.parse(storedQuery);
        router.replace({ pathname: router.pathname, query: parsedQuery }, undefined, { shallow: true });
      }
    }

    // Get stored form values from sessionStorage
    const storedValues = sessionStorage.getItem('bookingFormValues');
    if (storedValues) {
      setValues(JSON.parse(storedValues));
    }
  }, [router]);


  return (
    <>
      <Seo meta={meta} />
      {/* End Page Title */}

      <div className="header-margin"></div>
      {/* header top margin */}

      {/* <Header11 /> */}
      <Header11 bgColor="#f6f6f6" borderColor="#DFDFDF" />
      {/* End Header 1 */}

      {/* <section className="pt-80 layout-pb-md"> */}
      <section className="layout-pb-md">
        <div className="container">
          <h2 className="text-22 fw-500 mt-40 md:mt-24">
            Let us know who you are to proceed with your activity booking.
          </h2>
          {JSON.parse(sessionStorage.getItem('rslkey')) !== null ? (
            ''
          ) : (
            <div className="ptb-10">
              Do you want to continue as guest or{' '}
              <a href="#" onClick={handleBooking} className="sign-color">
                login
              </a>
              .
            </div>
          )}

          <StepperBooking
            setValues={setValues}
            values={values}
            searchCountryCodeValue={searchCountryCodeValue}
            setSearchCountryCodeValue={setSearchCountryCodeValue}
            setFormLoading={setFormLoading}
            formLoading={formLoading}
            vat={vat}
            withPickup={withPickup}
            // pickupPoint={pickupPoint}
            termAndCondition={termAndCondition}
          />
        </div>
        {/* End container */}
      </section>
      {/* End stepper */}

      <div
        className={`currencyMenu js-currencyMenu ${click ? '' : 'is-hidden'}`}
      >
        <div className="currencyMenu__bg" onClick={handleCurrency}></div>
        <div className="currencyMenu__signpop bg-white rounded-4">
          <div className="d-flex items-center justify-between px-30 py-20 sm:px-15 border-bottom-light">
            {/* End Title */}
            <div />

            <button className="pointer" onClick={handleCurrency}>
              <i className="icon-close" />
            </button>
            {/* End colse button */}
          </div>
          {/* End flex wrapper */}
          <div
            className="text-20 fw-500 lh-15 px-30  py-30 sm:px-15 sm:py-15"
            style={{
              textAlign: 'center',
            }}
          >
            To continue Booking, please sign in to your account
          </div>
          <div
            className="px-30  py-30 sm:px-15 sm:py-15"
            style={{
              textAlign: 'center',
            }}
          >
            <button
              className="btn bg-dark-3 text-white"
              onClick={() => {
                // router.push("/sign-in/sign-in");
                sessionStorage.setItem('isSig', true);
                setClick(false);
              }}
            >
              Sign In
            </button>
          </div>
        </div>
      </div>

      <CallToActions />
      {/* End Call To Actions Section */}

      <DefaultFooter />
    </>
  );
};

export default Index;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}